import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getBranchFleetList(params) {
  return request({
    url: URL.mdm.basicData.branchFleet + '/list',
    method: 'post',
    data: params
  })
}

export function saveBranchFleet(data) {
  if (data.uuid) {
    return request({
      url: URL.mdm.basicData.branchFleet + '/update',
      method: 'post',
      data
    })
  } else {
    return request({
      url: URL.mdm.basicData.branchFleet + '/add',
      method: 'post',
      data
    })
  }
}

export function deleteBranchFleet(uuids) {
  return request({
    url: URL.mdm.basicData.branchFleet + '/delete',
    method: 'post',
    data: uuids
  })
}

export function listBranchFleetByType(params) {
  return request({
    url: URL.mdm.basicData.branchFleet + '/listByType',
    method: 'post',
    data: params
  })
}
